"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mask = exports.defaultMaskOption = exports.isNotEmpty = exports.padStart = exports.padEnd = void 0;
var __1 = require("..");
var padEnd = function (str, length, fill) {
    if (fill === void 0) { fill = " "; }
    if (str.length >= length)
        return str.slice(0, length);
    return str.padEnd(length, fill);
};
exports.padEnd = padEnd;
var padStart = function (str, size, fill) {
    if (fill === void 0) { fill = " "; }
    if (str.length >= size)
        return str.slice(str.length - size, str.length);
    return str.padStart(size, fill);
};
exports.padStart = padStart;
var isNotEmpty = function (str) {
    if (__1.generic.isExist(str))
        return str !== "";
    else
        return false;
};
exports.isNotEmpty = isNotEmpty;
exports.defaultMaskOption = { enabled: true, front: 15, back: 15, mask: "*" };
var mask = function (str, opt) {
    if (!exports.isNotEmpty(str))
        return "";
    var option = Object.assign({}, exports.defaultMaskOption, opt);
    var limitFront = parseInt((str.length * (option.front / 100)).toFixed(0));
    var limitBack = parseInt((str.length * (option.back / 100)).toFixed(0));
    var preview = str.substr(0, limitFront);
    var endPreview = str.substring(str.length - limitBack, str.length);
    return preview.padEnd(str.length - limitBack, option.mask).concat(endPreview);
};
exports.mask = mask;
//# sourceMappingURL=string.js.map